import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import OnboardingContainer from '../Component/OnboardingContainer';
import { LoginAction } from '../auth/action';
import { useNavigate } from 'react-router-dom';
import { onLoggedIn } from '../../Function/onLoggedIn';
import { useDispatch } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { encryptPassword } from '../../Utils/Encryption/NodeForgeEncryption';

const LoginV2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginCredentials, setLoginCredentials] = useState({
    mobile: null,
    password: null,
  });
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [errors, setErrors] = useState({});
  const onFinishLogin = async () => {
    const newErrors = {};
    if (!loginCredentials?.mobile)
      newErrors.mobile = 'Enter a valid mobile number';

    if (loginCredentials?.mobile?.length < 10)
      newErrors.mobile = 'Enter a 10-digit mobile number';

    if (!loginCredentials?.password)
      newErrors.password = 'Enter a valid password';

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const encryptedUsername = encryptPassword(loginCredentials.mobile);
    const encryptedPassword = encryptPassword(loginCredentials.password);

    const { data, error, message } = await LoginAction({
      username: encryptedUsername,
      password: encryptedPassword,
    });
    if (error) return toast.error(message);
    onLoggedIn({
      data: data,
      error: error,
      message: message,
      navigate: navigate,
      dispatch: dispatch,
      toast: toast,
    });
  };
  const onLoginWithOTP = () => {
    if (!loginCredentials.mobile)
      return toast.error('Enter a valid mobile number');

    if (loginCredentials.mobile.length < 10)
      return toast.error('Enter 10 digit mobile number');

    navigate('/LoginViaOtp', {
      state: {
        phone_number: loginCredentials.mobile,
      },
    });
  };
  const handleForgotPassword = () => {
    if (!loginCredentials.mobile)
      return toast.error('Enter a valid mobile number');

    if (loginCredentials.mobile.length < 10)
      return toast.error('Enter 10 digit mobile number');

    navigate('/VerifyUserForForgotPassword', {
      state: {
        phone_number: loginCredentials.mobile,
      },
    });
  };
  const handleOnClickRegister = () => {
    navigate('/Register');
  };
  useEffect(() => {
    dispatch({
      type: 'RESET_FIRM_ONBOARDING_REDUCER',
    });
  }, []);
  return (
    <OnboardingContainer>
      <Box sx={{ pb: '4rem' }}>
        <Typography
          variant='h6'
          gutterBottom
          color={'#9CA3AF'}
          fontSize={'1.5rem'}
        >
          Welcome to the,
        </Typography>
        <Typography
          variant='h5'
          gutterBottom
          color={'white'}
          fontSize={'2rem'}
        >
          World of Goodness
        </Typography>
      </Box>
      <Typography
        variant='h5'
        color={'white'}
        fontSize={'2rem'}
      >
        Login
      </Typography>
      <Stack
        spacing={1}
        direction={'row'}
        alignItems={'center'}
        alignContent={'center'}
      >
        <Typography
          variant='subtitle2'
          gutterBottom
          color={'white'}
          fontSize={'1rem'}
        >
          Don't have an account ?{'  '}
        </Typography>
        <Button
          variant='text'
          onClick={handleOnClickRegister}
        >
          {' '}
          Register
        </Button>
      </Stack>
      <Stack
        sx={{ width: '80%' }}
        direction={'column'}
        spacing={2}
      >
        <FormControl
          error={!!errors.mobile}
          fullWidth
        >
          <TextField
            className='darkBackground'
            margin='normal'
            required
            fullWidth
            id='phoneNumber'
            label='Phone Number'
            name='phoneNumber'
            autoComplete='phoneNumber'
            autoFocus
            color='secondary'
            value={loginCredentials.mobile}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
                setLoginCredentials({
                  ...loginCredentials,
                  mobile: e.target.value,
                });
              }
            }}
          />
          {errors.mobile && <FormHelperText>{errors.mobile}</FormHelperText>}
        </FormControl>
        <FormControl
          error={!!errors.password}
          fullWidth
        >
          <TextField
            className='darkBackground'
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type={showPassword ? 'text' : 'password'}
            id='password'
            autoComplete='current-password'
            color='secondary'
            value={loginCredentials.password}
            onChange={(e) =>
              setLoginCredentials({
                ...loginCredentials,
                password: e.target.value,
              })
            }
            InputProps={{
              endAdornment: loginCredentials?.password?.length > 0 && (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleTogglePasswordVisibility}
                    edge='end'
                  >
                    {showPassword ? (
                      <VisibilityOff sx={{ color: 'white' }} />
                    ) : (
                      <Visibility sx={{ color: 'white' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {errors.password && (
            <FormHelperText>{errors.password}</FormHelperText>
          )}
        </FormControl>
        <Button
          variant='contained'
          color='primary'
          sx={{ width: '100%' }}
          onClick={onFinishLogin}
        >
          Login
        </Button>
      </Stack>
      <Stack
        sx={{ width: '80%' }}
        direction={'row'}
        spacing={2}
        justifyContent={'space-between'}
      >
        <Button
          variant='text'
          onClick={handleForgotPassword}
        >
          {' '}
          <Typography
            variant='subtitle2'
            gutterBottom
            color={'white'}
            fontSize={'.8rem'}
          >
            Forgot Password ?
          </Typography>
        </Button>
        <Button variant='text'>
          <Typography
            variant='subtitle2'
            gutterBottom
            color={'white'}
            fontSize={'.8rem'}
            onClick={onLoginWithOTP}
          >
            Login with OTP
          </Typography>
        </Button>
      </Stack>
    </OnboardingContainer>
  );
};

export default LoginV2;
